import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import olio from "../images/olio.jpeg"
import b from "../images/b.jpeg"
import IconButton from '@mui/material/IconButton';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from "./Button"
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import useWindowSize from "../utils";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        borderRadius: "20px",
        margin: "10%",
        display: "flex",
        border: "1px solid #707070",
        backgroundColor: "#f6f6f6",
        flexDirection: "column",
        overflow: "hidden",
        minHeight: "300px",
        marginTop: "4%"
    },
    imgO: {
        width: "100%",
        backgroundImage: `url(${olio})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        padding: "0px",
        borderRadius: "20px",
        border: "1px solid #707070",
    },
    imgB: {
        width: "100%",
        backgroundImage: `url(${b})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        padding: "0px",
        borderRadius: "20px",
        border: "1px solid #707070",
    },
    price: {
        display: "flex",
        float: "right",
        marginLeft: "auto",
        marginRight: "10px"
    },
}));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    borderRadius: "25px",
    boxShadow: 24,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    paddingTop: "2%"
};

export default function ProductCart({ value, handle, addInCart }) {
    const classes = useStyles();
    const val = value === "Olio" ? "6,5 €/Lt" : "1,1 €/Kg"
    const misura = value === "Olio" ? "Lt" : "Kg"
    const [open, setOpen] = useState(false)
    const [quantity, setQuantity] = useState(0)
    const { width } = useWindowSize();

    const handleOpen = () => {
        setQuantity(0);
        setOpen(!open)
    }

    const handleChange = (event) => {
        setQuantity(event.target.value);
    };

    return (
        <Grid constainer className={classes.container} onClick={() => handle(value)}
            style={width >= 550 ? {height: "30%", width: "30%",} : {height: "80%", width: "80%",}}>
            <Grid items xs={12} className={value === "Olio" ? classes.imgO : classes.imgB} />
            <div style={{ display: "flex", alignItems: "center", paddingLeft: "3%" }}>
                <h2>{value}</h2>
                <b className={classes.price} >{val}</b>
                <IconButton color="primary" onClick={() => handleOpen()}>
                    <AddShoppingCartIcon />
                </IconButton>
            </div>

            <Modal
                open={open}
                onClose={handleOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <FormControl variant="outlined">
                        <OutlinedInput
                            id="outlined-adornment-weight"
                            value={quantity}
                            type="number"
                            inputProps={{ step: 0.1, min: 0 }}
                            onChange={(e) => handleChange(e)}
                            endAdornment={<InputAdornment position="end">{misura}</InputAdornment>}
                        />
                        <FormHelperText >Inserisci la quantità</FormHelperText>
                    </FormControl>

                    <Button name="Aggiungi al carrello" onClick={() => {
                        if (quantity > 0) {
                            addInCart(value, quantity)
                        }
                        handleOpen()
                    }} />
                </Box>
            </Modal>
        </Grid>
    );
}